import { useCallback } from 'react';
import { FieldArray, useFormikContext } from 'formik';

import Grid from '@mui/material/Grid';

import { graphql } from '@e-socna/data-layer';

import type { ThirdPartyForm_Organization } from '../../fragments/organization.fragment';

import { MembershipsDetails } from './MembershipsDetails';

export const ThirdPartyForm_OrganizationMembershipsDetailsStep_Organization_Fragment =
  graphql(`
    fragment ThirdPartyForm_OrganizationMembershipsDetailsStep_Organization_Fragment on Organization {
      activeMemberships {
        _id
        personId
        functions
        contextualRoleIds
        representativeTypeIds
      }
    }
  `);

interface Props {
  readonly id: string;
  readonly isInternal: boolean;
}

export const ThirdPartyOrganizationMembershipsDetailsFormStep = ({
  isInternal,
}: Readonly<Props>) => {
  const {
    values: { activeMemberships },
  } = useFormikContext<ThirdPartyForm_Organization>();

  const fieldArrayRender = useCallback(
    () => (
      <MembershipsDetails
        activeMemberships={activeMemberships}
        isInternal={isInternal}
      />
    ),
    [activeMemberships, isInternal],
  );

  return (
    <Grid container sx={{ display: 'flex', flexGrow: 1 }}>
      <Grid size={12} sx={{ display: 'flex', flexDirection: 'column' }}>
        <FieldArray name="activeMemberships" render={fieldArrayRender} />
      </Grid>
    </Grid>
  );
};
